import { Children, isValidElement } from "react";
import { getter, orderBy } from "@nexthink/kendo-react";
import isEqual from "lodash/isEqual";
import { isTableActionSubMenu } from "./TableActionSubMenu";
export const TABLE_NAMESPACE = "table";
const PERCENTAGE_REGEX = /^\d+(.\d+)?%$/;
function singleOrderBy(data, descriptor) {
    return orderBy(data, descriptor ? [descriptor] : []);
}
export const areRowsEqual = (a, b, dataItemKey) => {
    const getById = dataItemKey ? getter(dataItemKey, true) : undefined;
    return getById ? getById(a) === getById(b) && getById(a) !== undefined : isEqual(a, b);
};
export function getDataItemIndex(data, dataItem, dataItemKey, rowEqualityFn = areRowsEqual) {
    return data.findIndex((row) => rowEqualityFn(row, dataItem, dataItemKey));
}
export const getJustifyContentFromTextAlign = (textAlignProp) => {
    switch (textAlignProp) {
        case "center":
            return "center";
        case "end":
        case "right":
            return "flex-end";
        default:
            return "flex-start";
    }
};
export const isPercentageValue = (value) => PERCENTAGE_REGEX.test(value);
export { singleOrderBy as orderBy, getter };
export const cellActions = (actions) => Children.map(actions, (c) => {
    if (!isValidElement(c)) {
        return undefined;
    }
    if (isTableActionSubMenu(c)) {
        return Object.assign(Object.assign({}, c.props), { isActionSubMenu: true });
    }
    return isValidElement(c) ? c.props : undefined;
}).filter(Boolean);
export const isFieldNumeric = (data, fieldName, numRowsToScan = 25) => {
    if (!data || !data.length) {
        return false;
    }
    const { hasNumeric, hasNonNumeric } = data
        .slice(0, numRowsToScan)
        .reduce((acc, row) => {
        const value = row === null || row === void 0 ? void 0 : row[fieldName];
        if (typeof value === "number") {
            acc.hasNumeric = true;
        }
        else if (value !== null) {
            acc.hasNonNumeric = true;
        }
        return acc;
    }, { hasNumeric: false, hasNonNumeric: false });
    return hasNumeric && !hasNonNumeric;
};
//# sourceMappingURL=utils.js.map